import { Gift, Sparkles, X } from 'lucide-react';

import { useHolidayStore } from '@/store/useHolidayStore';

export function RewardModal() {
  const { showReward, setShowReward, reward, burnedCount, totalGifts } = useHolidayStore();

  if (!showReward) return null;

  const burned = burnedCount();
  const total = totalGifts();

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 backdrop-blur-sm animate-modal-backdrop-in"
      onClick={() => setShowReward(false)}
    >
      <div
        className="relative bg-gradient-to-br from-red-900 via-red-800 to-green-900 rounded-2xl p-8 max-w-md mx-4 shadow-2xl animate-holiday-reward-reveal"
        onClick={(e) => e.stopPropagation()}
        style={{
          fontFamily: 'Outfit, sans-serif',
        }}
      >
        {/* Close button */}
        <button
          onClick={() => setShowReward(false)}
          className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Sparkles decoration */}
        <div className="absolute -top-6 -left-6 text-yellow-400 animate-holiday-sparkle">
          <Sparkles className="w-12 h-12" />
        </div>
        <div className="absolute -top-6 -right-6 text-yellow-400 animate-holiday-sparkle" style={{ animationDelay: '0.5s' }}>
          <Sparkles className="w-12 h-12" />
        </div>
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-yellow-400 animate-holiday-sparkle" style={{ animationDelay: '1s' }}>
          <Sparkles className="w-12 h-12" />
        </div>

        {/* Content */}
        <div className="text-center text-white">
          {/* Gift icon */}
          <div className="mb-4 flex justify-center">
            <div className="relative">
              <Gift className="w-20 h-20 text-yellow-400" />
              <div className="absolute inset-0 animate-ping">
                <Gift className="w-20 h-20 text-yellow-400/30" />
              </div>
            </div>
          </div>

          {/* Congratulations text */}
          <h2
            className="text-3xl font-bold mb-2"
            style={{ fontFamily: 'Hyperspace Race Capsule, cursive' }}
          >
            CONGRATULATIONS!
          </h2>

          <p className="text-lg text-white/80 mb-4">
            You burned all {total} gifts!
          </p>

          {/* Stats */}
          <div className="bg-black/30 rounded-xl p-4 mb-6">
            <div className="flex justify-center items-center gap-2">
              <span className="text-4xl font-bold text-yellow-400">{burned}</span>
              <span className="text-lg text-white/60">gifts burned</span>
            </div>
          </div>

          {/* Reward info (placeholder) */}
          {reward ? (
            <div className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl p-4 mb-6">
              <p className="text-sm text-black/60 mb-1">Your Reward</p>
              <p className="text-2xl font-bold text-black">
                {reward.type === 'points' ? `${reward.amount} Points` : `${reward.amount} ${reward.type}`}
              </p>
            </div>
          ) : (
            <div className="bg-white/10 rounded-xl p-4 mb-6">
              <p className="text-sm text-white/60 mb-1">Reward</p>
              <p className="text-lg">
                Check back soon for your reward!
              </p>
            </div>
          )}

          {/* Action button */}
          <button
            onClick={() => setShowReward(false)}
            className="w-full py-3 px-6 rounded-xl font-bold text-black transition-all transform hover:scale-105"
            style={{
              background: 'linear-gradient(92deg, #FB8B00 -4.02%, #F6DF6F 24.3%, #FB8B00 50.55%, #F6DF6F 72.17%, #FB8B00 103.05%)',
              fontFamily: 'Hyperspace Race Capsule, cursive',
            }}
          >
            AWESOME!
          </button>
        </div>
      </div>
    </div>
  );
}
